import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { filter, switchMap, takeUntil } from 'rxjs/operators'

import { Navigation } from '@shared/models/navigation.model'
import { PermissionsService } from '@shared/services/permissions.service'
import { Setting } from '@shared/models/setting.model'
import { AuthService } from '@app/modules/auth/auth.service'
import { SettingsService } from '@shared/common-components/settings/settings.service'
import { DestroyService } from '@core/services/destroy.service'
import { User } from '@shared/models/user.model'

@Component({
  selector: 'lin-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NavigationComponent implements OnInit {
  @Input() navigation: Navigation[]

  constructor(
    public permissionsService: PermissionsService,
    private readonly authService: AuthService,
    private readonly settingsService: SettingsService,
    private readonly destroyService: DestroyService,
  ) {}

  ngOnInit(): void {
    this.authService.currentUser$
      .pipe(
        filter(Boolean),
        switchMap((user: User) => this.settingsService.getSettings(user.team.id)),
        takeUntil(this.destroyService),
      )
      .subscribe((settings: Setting[]) => {
        this.settingsService.setVehicleDisplaySetting(settings)
      })
  }
}
